import { Ifilter } from "../../../Interfaces/filter";
import { fetchAdministracion } from "../../http-common";

const Empresa = "Empresa";

const ComboEmpresa= (request: Ifilter, controller = new AbortController()) => {
    return fetchAdministracion.get(`${Empresa}/ComboEmpresaFilter`, {
        params: request,
        signal: controller.signal,
    });
};
const EmpresaService = {
    ComboEmpresa
}

export { EmpresaService };